const isProduction = process.env.NODE_ENV === "production";
const API_URL = isProduction
  ? process.env.REACT_APP_PRODUCTION_SERVER_URL
  : process.env.REACT_APP_LOCAL_SERVER_URL;
export default API_URL;